import React, { useState, useEffect } from 'react';
import { bookingsAPI } from '../utils/api';

function CustomerSearch({ onSelect, selectedCustomer }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showResults, setShowResults] = useState(false);

  useEffect(() => {
    const searchCustomers = async () => {
      if (searchTerm.length < 2) {
        setResults([]);
        return;
      }

      setLoading(true);
      try {
        const response = await bookingsAPI.searchCustomers(searchTerm);
        setResults(response.data);
        setShowResults(true);
      } catch (error) {
        console.error('Error searching customers:', error);
        setResults([]);
      } finally {
        setLoading(false);
      }
    };

    const debounce = setTimeout(() => {
      searchCustomers();
    }, 300);

    return () => clearTimeout(debounce);
  }, [searchTerm]);

  const handleSelect = (customer) => {
    onSelect(customer);
    setSearchTerm(customer.name);
    setShowResults(false);
  };

  const handleClear = () => {
    setSearchTerm('');
    setResults([]);
    onSelect(null);
  };

  return (
    <div style={{ position: 'relative' }}>
      <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
        <input
          type="text"
          placeholder="Search by name, email, or phone..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onFocus={() => results.length > 0 && setShowResults(true)}
          className="form-control"
          style={{ flex: 1 }}
        />
        {selectedCustomer && (
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleClear}
          >
            Clear
          </button>
        )}
      </div>

      {loading && (
        <div style={{ padding: '0.5rem', color: '#666', fontSize: '0.9rem' }}>
          Searching...
        </div>
      )}

      {showResults && results.length > 0 && (
        <div
          style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            background: 'white',
            border: '1px solid #ddd',
            borderRadius: '8px',
            marginTop: '0.25rem',
            maxHeight: '300px',
            overflowY: 'auto',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            zIndex: 1000
          }}
        >
          {results.map((customer) => (
            <div
              key={customer.id}
              onClick={() => handleSelect(customer)}
              style={{
                padding: '0.75rem 1rem',
                cursor: 'pointer',
                borderBottom: '1px solid #f0f0f0',
                transition: 'background-color 0.2s'
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
              onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
            >
              <div style={{ fontWeight: '600', marginBottom: '0.25rem' }}>
                {customer.name}
              </div>
              <div style={{ fontSize: '0.85rem', color: '#666' }}>
                {customer.email} • {customer.phone}
              </div>
              <div style={{ fontSize: '0.8rem', color: '#999', marginTop: '0.25rem' }}>
                {customer.booking_count || 0} bookings
                {customer.last_booking && ` • Last: ${new Date(customer.last_booking).toLocaleDateString()}`}
              </div>
            </div>
          ))}
        </div>
      )}

      {searchTerm.length >= 2 && !loading && results.length === 0 && (
        <div style={{
          padding: '1rem',
          textAlign: 'center',
          color: '#666',
          fontSize: '0.9rem',
          marginTop: '0.5rem'
        }}>
          No customers found
        </div>
      )}
    </div>
  );
}

export default CustomerSearch;
